import toast from "react-hot-toast";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

export const useCreatePatientLetter = () => {
  const queryClient = useQueryClient();
  const tenantVal = localStorage.getItem("kinesin-tenant") ?? "";

  return useMutation({
    mutationFn: async (letterData) => {
      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.post(
        `${tenantVal}/patientletter`,
        letterData
      );

      return response.data;
    },
    onSuccess: () => {
      toast.success("Letter saved");
      queryClient.invalidateQueries({ queryKey: ["patientLetters"] });
    },
    onError: () => {
      toast.error("Failed to save letter");
    },
  });
};
